__turbopack_context__.v({
  "addressLine": "dedicated-footer-module__Vj-ZHq__addressLine",
  "bottom": "dedicated-footer-module__Vj-ZHq__bottom",
  "brand": "dedicated-footer-module__Vj-ZHq__brand",
  "columns": "dedicated-footer-module__Vj-ZHq__columns",
  "contact": "dedicated-footer-module__Vj-ZHq__contact",
  "creci": "dedicated-footer-module__Vj-ZHq__creci",
  "footer": "dedicated-footer-module__Vj-ZHq__footer",
  "identityRow": "dedicated-footer-module__Vj-ZHq__identityRow",
  "legal": "dedicated-footer-module__Vj-ZHq__legal",
  "name": "dedicated-footer-module__Vj-ZHq__name",
  "paymentCard": "dedicated-footer-module__Vj-ZHq__paymentCard",
  "paymentFallback": "dedicated-footer-module__Vj-ZHq__paymentFallback",
  "paymentLogo": "dedicated-footer-module__Vj-ZHq__paymentLogo",
  "paymentMethods": "dedicated-footer-module__Vj-ZHq__paymentMethods",
  "paymentTitle": "dedicated-footer-module__Vj-ZHq__paymentTitle",
  "payments": "dedicated-footer-module__Vj-ZHq__payments",
  "platformIcon": "dedicated-footer-module__Vj-ZHq__platformIcon",
  "socials": "dedicated-footer-module__Vj-ZHq__socials",
});
